/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
import { Box, FormHelperText, TextField } from "@mui/material";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { MAXIMUM_CORRECT_OPTION_CONSTRUCTED_RESPONSE_LENGTH } from "../../utils/constant";

type ConstructedResponseCardProps = {
  question: any;
  answerTotalQuestion: any;
  solutionData: any;
  onChangeAnswer: (answerContent: string, questionId: number) => void;
};

const ConstructedResponseCard = ({
  question,
  answerTotalQuestion,
  solutionData,
  onChangeAnswer
}: ConstructedResponseCardProps) => {
  const intl = useIntl();

  const isInvalidInput =
    answerTotalQuestion?.selections?.[0]?.length > MAXIMUM_CORRECT_OPTION_CONSTRUCTED_RESPONSE_LENGTH;

  return (
    <div className="flex flex-col gap-6">
      {!solutionData && (
        <p className="text-gray-900 font-semibold">
          <FormattedMessage id="arenaQuiz.constructedResponse.title" />
        </p>
      )}
      <div>
        <span
          dangerouslySetInnerHTML={{
            __html: question.description_answer_before
          }}
          className="[&>p]:inline text-[15px]"
        />
        &nbsp;
        {solutionData ? (
          <span
            className={`inline-block min-w-[172px] min-h-[36px] text-[13px] text-white px-6 py-[10px] rounded-[8px] ${
              solutionData?.skipped ? "bg-orangeQuiz" : solutionData?.correct ? "bg-greenQuiz" : "bg-red"
            }`}
          >
            {solutionData?.skipped ? solutionData?.correct_options[0] : solutionData?.answered_options?.[0]}
          </span>
        ) : (
          <Box width={202} display="inline-flex" alignItems="baseline" my={0.5}>
            <TextField
              size="small"
              placeholder={intl.formatMessage({ id: "arenaQuiz.constructedResponse.input.placeholder" })}
              className="h-[36px] placeholder:text-[13px] placeholder:text-gray1 text-blackQuiz mb-4"
              InputProps={{
                className: "text-[13px] align-baseline"
              }}
              value={answerTotalQuestion?.selections?.[0]}
              onChange={(event) => onChangeAnswer(event.target.value, question.id)}
              fullWidth
              error={isInvalidInput}
              helperText={
                isInvalidInput && (
                  <FormHelperText className="m-0">
                    <FormattedMessage id="Quá giới hạn ký tự cho phép" />
                  </FormHelperText>
                )
              }
            />
          </Box>
        )}
        &nbsp;
        <span
          dangerouslySetInnerHTML={{
            __html: question.description_answer_after
          }}
          className="[&>p]:inline text-[15px]"
        />
      </div>
      {solutionData && <span className="text-[13px] text-gray1 ">{solutionData?.correct_options[0]}</span>}
    </div>
  );
};

export default ConstructedResponseCard;
